var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"interaction-close btn-float top right",on:{"click":(evt) => _vm.$emit('click', evt)}},[_c('i',{staticClass:"mdi mdi-close"})])
}
var staticRenderFns = []

export { render, staticRenderFns }